import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { getPotentialRebatesSum } from 'site-modules/shared/components/incentives/incentives-wizard/utils/get-potential-rebates-sum';
import { InventoryEvInsightsEntities } from 'client/data/models/inventory-ev-insights';
import { IncentivesWizardEntities } from 'client/data/models/incentives-wizard';
import { buildEligibleIncentives } from 'site-modules/shared/components/incentives/incentives-wizard/utils/build-eligible-incentives';
import { isUnknownZip } from 'site-modules/shared/utils/location';
import { VisitorEntities, VisitorModel } from 'client/data/models/visitor';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  Shop3751AxConfigDefaultValues,
  Shop3751AxConfigEntity,
} from 'site-modules/shared/components/incentives/incentives-wizard/utils/with-shop-3751-wiz-ax';
import { RebatesAmount } from './rebates-amount/rebates-amount';

function getWizardCopy({ totalRebates, wizardState, make, model, shop3751AxConfig, zipCode, isUnknownLocation }) {
  const {
    copyShop3751: { isNoValueCopy, isSavingsPotentialCopy },
    designShop3751: { withIcon, withIconColor, withColor },
  } = shop3751AxConfig;
  const rebateAmountClassName = withIcon || withIconColor || withColor ? 'ax-gradient' : undefined;

  if (isNoValueCopy) {
    return `Check ${make} ${model} rebates and discounts before you buy`;
  }

  if (isSavingsPotentialCopy) {
    return (
      <>
        <div>
          <RebatesAmount value={wizardState && totalRebates} className={rebateAmountClassName} /> {make} {model} rebates
          in {zipCode}
        </div>
        <div className="fw-normal" style={{ fontSize: '0.875rem', lineHeight: '1.25rem', marginTop: '4px' }}>
          Check your savings potential before you buy
        </div>
      </>
    );
  }

  return (
    <>
      Save{' '}
      {isUnknownLocation ? (
        'on your purchase'
      ) : (
        <>
          up to <RebatesAmount value={wizardState && totalRebates} />
        </>
      )}{' '}
      with EV Tax Credits & Rebates
    </>
  );
}

function SrpTopIncentivesTextUI({
  incentives,
  className,
  textColorClassName,
  wizardState,
  visitorLocation,
  shop3751AxConfig,
  make,
  model,
}) {
  const eligibleIncentives = isEmpty(wizardState)
    ? incentives
    : buildEligibleIncentives(incentives, wizardState.eligibleIncentiveIds);
  const totalRebates = getPotentialRebatesSum(eligibleIncentives);
  const isUnknownLocation = isUnknownZip(visitorLocation);

  return (
    <h2
      className={classnames('mb-0 fw-bold', textColorClassName, className)}
      style={{ lineHeight: '1.5rem', fontSize: '1.25rem' }}
    >
      {getWizardCopy({
        totalRebates,
        wizardState,
        make,
        model,
        shop3751AxConfig,
        zipCode: visitorLocation?.zipCode,
        isUnknownLocation,
      })}
    </h2>
  );
}

SrpTopIncentivesTextUI.propTypes = {
  incentives: InventoryEvInsightsEntities.EvIncentivesData.isRequired,
  className: PropTypes.string,
  textColorClassName: PropTypes.string,
  wizardState: IncentivesWizardEntities.IncentivesWizardUnwrappedPersistedState,
  visitorLocation: VisitorEntities.Location,
  shop3751AxConfig: Shop3751AxConfigEntity,
  make: PropTypes.string,
  model: PropTypes.string,
};
SrpTopIncentivesTextUI.defaultProps = {
  className: null,
  textColorClassName: 'text-cool-gray-10',
  wizardState: undefined,
  visitorLocation: {},
  shop3751AxConfig: Shop3751AxConfigDefaultValues,
  make: '',
  model: '',
};

export const SrpTopIncentivesText = connectToModel(SrpTopIncentivesTextUI, {
  visitorLocation: bindToPath('location', VisitorModel, null, false),
});
